import {createBrowserHistory, createHashHistory} from "history";
import store from "./store/index";
import {currentRouterPath, emitInternalEvent} from "./helper/tracker/internalEvents";

export const canHandleDeeplinks = () => {
    return !!document.querySelector("#app-root[data-seo-deeplinks]");
};

const basePath = () => {
    try {
        const manufacturerName = store.getState().config.dealerDetails.dealership.manufacturerName;
        const isGroupShop = !!store.getState().config.garageId || !!store.getState().config.garageGroupId;
        return (isGroupShop && manufacturerName) ? `/brand/${manufacturerName}` : "";
    } catch {
        return "";
    }
};

const history = canHandleDeeplinks()
    ? createBrowserHistory()
    : createHashHistory();

history.listen(function () {
    emitInternalEvent("navigate", {
        router_path: currentRouterPath(),
        full_url: window.location.href,
    });
});

history["entry"] = history.length; // history.location.key was removed
history["pushHome"] = () => history.push(basePath() + "/shop");
history["pushSearch"] = (fuzzy = "") => history.push(basePath() + `/search/${encodeURIComponent(fuzzy)}`);
history["pushCheckout"] = () => history.push(basePath() + "/checkout");
history["pushBookmarks"] = () => history.push(basePath() + "/bookmarks");
history["pushCategory"] = (category = "") => history.push(basePath() + `/products/${category}`);

history["pushProduct"] = (productId, name = "") =>
    history.push(basePath() + `/product/${productId}/${encodeURIComponent(name)}`);

history["getProductUrl"] = (productId, name = "") =>
    basePath() + `/product/${productId}/${encodeURIComponent(name)}`;
history["getCategoryUrl"] = (category = "") => basePath() + `/products/${encodeURIComponent(category)}/`;

export default history;
